import { useCallback, useMemo } from 'react'

import useUrlState from '@ahooksjs/use-url-state'

import { DetailUrlState } from '../utils/type'

export const useStatementDetailUrlState = () => {
  const [queryParams, setQueryParams] = useUrlState<DetailUrlState>()

  const plans = useMemo<string[]>(() => {
    if (!queryParams.plans) {
      return []
    }
    return queryParams.plans.split(',')
  }, [queryParams.plans])
  const setPlans = useCallback(
    (newPlans: string[]) => {
      setQueryParams({ plans: newPlans.join(',') || undefined })
    },
    [setQueryParams]
  )

  // TODO: extract to reuse
  const slowQuerySortRules = useMemo(() => {
    const rules = (queryParams.slowquery_sort || '')
      .split(',')
      .filter((s: string) => s !== '')
      .map((s: string) => {
        if (s.startsWith('-')) {
          return {
            id: s.slice(1),
            desc: true
          }
        }
        return {
          id: s,
          desc: false
        }
      })
    return rules
  }, [queryParams.slowquery_sort])

  const setSlowQuerySortRules = useCallback(
    (newSortRules: any) => {
      const sort = newSortRules
        .map((rule: { id: string; desc: boolean }) => {
          if (rule.desc) {
            return `-${rule.id}`
          }
          return rule.id
        })
        .join(',')
      setQueryParams({ slowquery_sort: sort || undefined })
    },
    [setQueryParams]
  )

  return {
    ...queryParams,
    plans,
    setPlans,
    slowQuerySortRules,
    setSlowQuerySortRules
  }
}
